@if (component.data$ | async; as data) {
  <div
  [innerHTML]="bypassSecurityTrustHtml(data.content | cxSupplementHashAnchors)"></div>
}